import { getUserMe } from "@/services/me";
import { myApps } from "@/services/apps";
import * as Sentry from "@sentry/vue";
import { toLogin } from "@/utils/redirects";
import { State } from "@/utils/interfaces";

export const SET_ME = "setMe";
export const SET_MY_APPS = "setMyApps";

const state: State = {
  me: {
    _2fa: "TOTP",
  },
  myApps: [],
  authToken: "",
  appModified: undefined,
  loadingShow: false,
  users: [],
  apps: [],
  logs: undefined
};

const getters = {
  me: ({ me }: State): any => me,
  myApps: ({ myApps }: State): any => myApps,
};

const mutations = {
  [SET_ME](state: State, payload: any): void {
    state.me = payload;
  },
  [SET_MY_APPS](state: State, payload: any): void {
    state.myApps = payload;
  },
};

const actions = {
  setMe: ({ commit }: any, me: any): void => {
    commit(SET_ME, me);
  },

  fetchMe: async ({ dispatch }: any): Promise<any> => {
    try {
      const me = await getUserMe();
      dispatch("setMe", me.data);

      if (me.data.id) {
        Sentry.setUser({
          id: me.data.id,
          email: me.data.email,
          username: me.data.name,
        });
      }

      return me.data;
    } catch (error) {
      toLogin();
    }
  },

  actionsSetMyApps: ({ commit }: any, myapps: any): void => {
    commit(SET_MY_APPS, myapps);
  },

  actionsMyApps: ({ dispatch }: any, user_id: string): any => {
    return myApps(user_id).then((myApps: any) => {
      dispatch("actionsSetMyApps", myApps.data);
      return myApps.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
